import { createCommand, $getSelection, type LexicalCommand, type LexicalEditor } from 'lexical';
import { applyStyle } from '../utils/applyStyle';

export const SET_FONT_SIZE_COMMAND: LexicalCommand<string> = createCommand('SET_FONT_SIZE_COMMAND');

export function registerFontSizeCommand(editor: LexicalEditor) {
    return editor.registerCommand<string>(
        SET_FONT_SIZE_COMMAND,
        (fontSize) => {
            const selection = $getSelection();
            applyStyle(selection, 'font-size', fontSize);
            return true;
        },
        0
    );
}
